<template>

    <article v-bind:class="['figure-pop', tienePromocion ? 'with-promotion' : '']"> 
        <figure>
            <div class="new-tag" v-if="diferenciaFecha(pop)">Recién llegado</div>
            <div class="promotion-tag" v-if="tienePromocion">
                Figura con descuento
            </div>
            <div v-if="tieneDetalleHabilitado" class="figure-info-actions">
                <button
                    v-if="tieneDetalleHabilitado"
                    v-bind:class="['detail-info', detalleInfoAbierto ? 'is-open': '']"
                    type="button"
                    aria-label="Informacion sobre piezas con detalle"
                    @click.stop="detalleInfoAbierto = !detalleInfoAbierto"
                    @blur="detalleInfoAbierto = false"
                >
                    <span class="info-icon" aria-hidden="true">i</span>
                    <span class="detail-tooltip">
                        Una o más piezas llegaron con detalle/daño en caja por lo que se ofrecen a menor precio por si te interesa alguna de ellas.
                    </span>
                </button>
            </div>
            <img
                :src="pop.imagenUrl"
                :alt="textoAlternativoImagen"
                loading="lazy"
                decoding="async"
                width="232"
                height="232"
            />
        </figure>
        <div class="figure-badges">
            <div v-if="cantidadDisponibleReal === 1" class="type-pop last-figure-badge">
                Última pieza
            </div>
            <div class="type-pop">{{pop.tipoPop}}</div>
        </div>
        
        <div class="product-details">
            <h3>{{pop.licencia}} - {{nombreVisible}}</h3>
            <div class="purchase-row">
                <div class="price-details">
                    <template v-if="mostrarPrecioDetalle">
                        <div class="price-row">
                            <span class="price promotion-price">
                                ${{precioDetalleTarjeta}}
                            </span>
                            <span class="price withDiscount">
                                ${{pop.precioPublico}}
                            </span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="price-row">
                            <span v-if="pop.descuentoPrecioPublico > 0" class="price promotion-price">
                                ${{pop.precioPublico - pop.descuentoPrecioPublico}} 
                            </span>
                            <span v-bind:class="['price',pop.descuentoPrecioPublico > 0 ? 'withDiscount': '']">
                                ${{pop.precioPublico}}
                            </span>
                        </div>
                    </template>
                    <div v-if="existencia">
                        Cantidad disponible: {{cantidadDisponibleReal}}
                    </div>
                </div>
                <div class="purchase-actions">
                    <label
                        v-bind:class="['selector-carrito', seleccionado ? 'is-selected' : '']"
                        :for="'seleccionar-' + pop.llavePop"
                        :aria-label="seleccionado ? 'Figura seleccionada' : 'Seleccionar figura'"
                    >
                        <input
                            :id="'seleccionar-' + pop.llavePop"
                            type="checkbox"
                            :checked="seleccionado"
                            @change="actualizarSeleccion"
                        >
                        <span class="cart-icon" aria-hidden="true">
                            <svg v-if="!seleccionado" viewBox="0 0 24 24">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h8.7a2 2 0 0 0 2-1.6L22 6H6"></path>
                            </svg>
                            <svg v-else viewBox="0 0 24 24">
                                <path d="M20 6L9 17l-5-5"></path>
                            </svg>
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </article>
</template>

<script>

import moment from 'moment';
import { validacionDisponibilidad } from '@/utils/inventario';

export default{
    emits: ['seleccion-actualizada', 'solicitar-detalle'],
    props: {
        'pop': {
            type: Object
        },
        'existencia' : {
            type: Boolean
        },
        'seleccionado' : {
            type: Boolean
        },
        'mostrarPrecioDetalle' : {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            detalleInfoAbierto: false,
        }
    },
    methods: {
        diferenciaFecha(pop){
            //console.log(pop);
            const fechaLlegada = pop.fechaLlegada;
            //console.log(fechaLlegada);
            var end = moment(moment.utc()); 
            var days = end.diff(fechaLlegada, "days", true); 
            if(days <= 0 || days >= 8){
                return false
            }
            else if(days <= 7){
                return true
            }
              //console.log(days)
        },
        actualizarSeleccion(event){
            if(!event.target.checked){
                this.$emit('seleccion-actualizada', {
                    llavePop: this.pop.llavePop,
                    seleccionado: false,
                    usarDetalle: false,
                });
                return;
            }

            if(this.tieneDetalleHabilitado && this.tienePrecioDetalle){
                event.target.checked = false;
                this.$emit('solicitar-detalle', {
                    pop: this.pop,
                });
                return;
            }

            this.$emit('seleccion-actualizada', {
                llavePop: this.pop.llavePop,
                seleccionado: true,
                usarDetalle: false,
            });
        },
        obtenerOpcionesDetalle(){
            const listasPosibles = [
                this.pop.opcionesDetalle,
                this.pop["opciones detalle"],
                this.pop.preciosDetalle,
                this.pop["precios detalle"],
                this.pop.figurasDetalle,
                this.pop["figuras detalle"],
                this.pop.figurasConDetalle,
                this.pop["figuras con detalle"],
                this.pop.detalles,
                this.pop.detalle,
            ];
            const listaDetalle = listasPosibles.find(lista => {
                if(Array.isArray(lista)){
                    return lista.length > 0;
                }

                return lista && typeof lista === "object" && Object.keys(lista).length > 0;
            });

            if(listaDetalle){
                const detalles = Array.isArray(listaDetalle) ? listaDetalle : Object.values(listaDetalle);
                return detalles.filter(detalle => {
                    const precio = detalle.precioDetalle !== undefined ? detalle.precioDetalle : detalle.precio;

                    return precio !== null && precio !== undefined && precio !== "";
                });
            }

            if(this.pop.precioDetalle !== null && this.pop.precioDetalle !== undefined && this.pop.precioDetalle !== ""){
                return [{ precioDetalle: this.pop.precioDetalle }];
            }

            return [];
        },
        limpiarNombreControlInterno(nombre){
            return String(nombre || "").replace(/\s*\(R\d+\)\s*/gi, " ").replace(/\s{2,}/g, " ").trim();
        },
    },
    computed: {
        nombreVisible(){
            return this.limpiarNombreControlInterno(this.pop.nombre);
        },
        textoAlternativoImagen(){
            return `Funko Pop ${this.pop.licencia} - ${this.nombreVisible}`;
        },
        disponibilidad(){
            return validacionDisponibilidad(this.pop);
        },
        cantidadDisponibleReal(){
            return this.disponibilidad[0];
        },
        tieneDetalleHabilitado(){
            return this.pop.habilitadoDetalle === true || this.pop["habilitado detalle"] === true;
        },
        tienePrecioDetalle(){
            return this.obtenerOpcionesDetalle().length > 0;
        },
        tienePromocion(){
            return Number(this.pop.descuentoPrecioPublico) > 0 || this.mostrarPrecioDetalle;
        },
        precioDetalleTarjeta(){
            const primeraOpcion = this.obtenerOpcionesDetalle()[0];

            if(!primeraOpcion){
                return "";
            }

            return primeraOpcion.precioDetalle !== undefined ? primeraOpcion.precioDetalle : primeraOpcion.precio;
        },
    },
    
}

</script>

<style lang="scss" scoped>

    @function pxToRem($value) {
        $remValue: ($value / 16) + rem; 
        @return $remValue;
    }

    .figure-pop{
        position: relative;
        background: #fff;
        //transition: all .2s ease;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.16);
        color: #111;
        height: 100%;
        border-radius: 0.5rem;
        border: 4px solid transparent;
        display: flex;
        flex-direction: column;
        align-items: center;
        &.with-promotion{
            border-color: #ffd84d;
        }
        figure{
            margin-bottom: 0;
            position:relative;
        }
        img{
            border-top-left-radius: 0.5rem;
            border-top-right-radius: 0.5rem;
            max-width: 100%;
            height: auto;
        }
        .figure-info-actions{
            align-items: center;
            display: flex;
            gap: pxToRem(6);
            left: pxToRem(8);
            position: absolute;
            top: pxToRem(32);
            z-index: 3;
        }
        .promotion-tag{
            background-color: #ffd84d;
            color: black;
            font-weight: 500;
            padding: 0.3125rem 0.75rem;
            position: absolute;
            top: 0;
            font-size: pxToRem(12);
            line-height: 1;
            @media (min-width: 767px){
                padding: 0.3125rem 1.25rem;
            }
        }
        .detail-info{
            align-items: center;
            background-color: rgba(255, 248, 219, 0.96);
            border: 1px solid rgba(169, 121, 0, 0.28);
            border-radius: 999px;
            color: #7a5700;
            cursor: pointer;
            display: flex;
            height: pxToRem(28);
            justify-content: center;
            padding: 0;
            position: relative;
            width: pxToRem(28);
            .info-icon{
                align-items: center;
                display: flex;
                font-size: pxToRem(16);
                font-weight: bold;
                height: 100%;
                justify-content: center;
                line-height: 1;
                width: 100%;
            }
            .detail-tooltip{
                background: #222;
                border-radius: 0.35rem;
                bottom: calc(100% + 0.5rem);
                color: #fff;
                display: none;
                font-size: pxToRem(12);
                font-weight: bold;
                line-height: 1.25;
                padding: pxToRem(8) pxToRem(10);
                position: absolute;
                left: 0;
                text-align: left;
                width: pxToRem(190);
                z-index: 4;
            }
            &:hover,
            &.is-open{
                color: #222;
                .detail-tooltip{
                    display: block;
                }
            }
        }
        .new-tag{
            background-color: #63b4c1;
            color: white;
            font-weight: bold;
            padding: 0.3125rem 0.75rem;
            position: absolute;
            bottom: 0px;
            left: 0;
            //border-bottom-right-radius: 0.5rem;
            font-size: pxToRem(12);
            line-height: 1;
            @media (min-width: 767px){
                padding: 0.3125rem 1.25rem;
            }
        }
        .product-details{
            box-sizing: border-box;
            padding: pxToRem(10);
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;
            width: 100%;
            @media (min-width: 767px){
                padding: pxToRem(12);
            }
            h3{
                font-weight: 500;
                font-size: pxToRem(12);
                margin: 0 0 pxToRem(5);
                flex: 1 1 0%;
                @media (min-width: 767px){
                    font-size: pxToRem(16);
                }
            }
            .purchase-row{
                align-items: end;
                display: grid;
                gap: pxToRem(8);
                grid-template-columns: minmax(0, 1fr) auto;
            }
            .price-details{
                min-width: 0;
            }
            .price-row{
                align-items: baseline;
                display: flex;
                flex-wrap: wrap;
                gap: pxToRem(6);
            }
            .purchase-actions{
                align-items: center;
                display: flex;
                gap: pxToRem(6);
                justify-content: flex-end;
            }
            .price{
                //flex: 1 0 auto;
                color: #11824c;
                font-size: pxToRem(14);
                font-weight: 500;
                letter-spacing: 0;
                line-height: 1.1;
                position: relative;
                width: fit-content;
                @media (min-width: 767px){
                    font-size: pxToRem(18);
                }
                &.withDiscount{
                    color: #999;
                    font-size: pxToRem(12);
                    font-weight: 700;
                    &:after{
                        border-top: 1px solid;
                        position: absolute;
                        content: "";
                        right: 0;
                        top: 50%;
                        left: 0;
                    }
                }
                &.promotion-price{
                    color: #FF4500;
                }
            }
            .selector-carrito{
                align-items: center;
                background: #0b94cf;
                border: 1px solid #fff;
                border-radius: 0.35rem;
                color: #fff;
                cursor: pointer;
                display: flex;
                flex: 0 0 auto;
                gap: pxToRem(4);
                height: pxToRem(30);
                justify-content: center;
                padding: pxToRem(4) pxToRem(3);
                position: relative;
                transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
                width: pxToRem(42);
                input{
                    height: 1px;
                    opacity: 0;
                    overflow: hidden;
                    position: absolute;
                    width: 1px;
                    &:focus-visible + .cart-icon{
                        outline: 2px solid #0b94cf;
                        outline-offset: 3px;
                    }
                }
                .cart-icon{
                    display: flex;
                    svg{
                        fill: none;
                        height: pxToRem(16);
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 2;
                        width: pxToRem(16);
                    }
                }
                &:hover{
                    background: #0878a7;
                    border-color: #fff;
                    color: #fff;
                }
                &.is-selected{
                    background: #0878a7;
                    border-color: #fff;
                    color: #fff;
                    .cart-icon{
                        svg{
                            stroke-width: 2.3;
                            .cart-product-fill{
                                fill: currentColor;
                                stroke: currentColor;
                            }
                        }
                    }
                    &:hover{
                        background: #0b94cf;
                        border-color: #fff;
                        color: #fff;
                    }
                }
            }
        }
        .figure-badges{
            align-self: flex-end;
            align-items: center;
            display: flex;
            flex-wrap: wrap;
            gap: pxToRem(5);
            justify-content: flex-end;
            margin: pxToRem(6) pxToRem(10) 0;
            max-width: calc(100% - #{pxToRem(20)});
            @media (min-width: 767px){
                margin-right: pxToRem(12);
            }
        }
        .type-pop{
            background-color: rgba(66, 184, 131, 0.12);
            border: 1px solid rgba(66, 184, 131, 0.32);
            border-radius: 999px;
            color: #247a55;
            font-weight: bold;
            font-size: pxToRem(11);
            line-height: 1.2;
            padding: pxToRem(3) pxToRem(8);
            @media (min-width: 767px){
                font-size: pxToRem(12);
            }
            &.last-figure-badge{
                background-color: rgba(208, 52, 44, 0.1);
                border-color: rgba(208, 52, 44, 0.28);
                color: #D0342C;
            }
        }
    }


</style>
